import { render, staticRenderFns } from "./BottomNavigationButton.vue?vue&type=template&id=3fd855b0&scoped=true&"
import script from "./BottomNavigationButton.vue?vue&type=script&lang=js&"
export * from "./BottomNavigationButton.vue?vue&type=script&lang=js&"
import style0 from "./BottomNavigationButton.vue?vue&type=style&index=0&id=3fd855b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd855b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VBtn,VIcon})
